export default [
  {
    path: "/admin/dealers-account-maintenance/dealers",
    name: "dealers-account-maintenance.dealers.index",
    component: () => import("../Index.vue"),
    meta: {
      title: "Dealers",
      description: "Manage Dealers",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "colors",
      roles: ["admin"]
    },
  },
  {
    path: "/admin/dealers-account-maintenance/dealers/create",
    name: "dealers-account-maintenance.dealers.create",
    component: () => import("../Create.vue"),
    meta: {
      title: "Add new Dealer",
      description: "Create new Dealer",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "colors",
      roles: ["admin"]
    },
  },
  {
    path: "/admin/dealers-account-maintenance/dealers/:id/edit",
    name: "dealers-account-maintenance.dealers.edit",
    component: () => import("../Edit.vue"),
    meta: {
      title: "Edit Dealer",
      sort: 0,
      authenticatable: true,
      permission: false,
      roles: ["admin"]
    },
  },
  {
    path: "/admin/dealers-account-maintenance/dealers/:id/sales-consultants",
    name: "dealers-account-maintenance.dealers.salesconsultants",
    component: () => import("../SalesConsultants.vue"),
    meta: {
      title: "Dealer Sales Consultants",
      sort: 0,
      authenticatable: true,
      permission: false,
      roles: ["admin"]
    },
  },
];
